export const COMMON_CODE="/common/code";
export const COMMON_VERIFY_CODE="/common/verify/code";
export const COMMON_VERIFY="/common/verify";